/* eslint no-param-reassign:0 */
import { normalizePosition } from './position.normalizer';

const toTimestamp = (value) => Number(value) || 0;

// A vehicle has one last position per device and the API returns them in no guaranteed order,
// while the UI reads lastPosition[0] as "the" last position - so put the freshest one first.
const byNewestPositionFirst = (a, b) => (
  toTimestamp(b.positionTimestamp) - toTimestamp(a.positionTimestamp)
  || toTimestamp(b.serverTimestamp) - toTimestamp(a.serverTimestamp)
);

export function normalizeVehicleInPlace(vehicle) {
  if (vehicle?.vehicle?.lastPosition?.length > 1) {
    vehicle.vehicle.lastPosition.sort(byNewestPositionFirst);
  }

  const lastPosition = vehicle && vehicle.vehicle
    && vehicle.vehicle.lastPosition && vehicle.vehicle.lastPosition.length && vehicle.vehicle.lastPosition[0];

  if (lastPosition) {
    vehicle.vehicle.lastPosition[0] = normalizePosition(lastPosition);
  }

  vehicle.computedId = `${vehicle.companyId}_${vehicle.vehicleId}_${vehicle.vehicle?.vehicleCompany?.id}`;

  return vehicle;
}

export function normalizeVehiclesInPlace(vehicles) {
  return vehicles.map((vehicle) => normalizeVehicleInPlace(vehicle));
}
